import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: clip;
`;

export const MainSection = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  box-sizing: border-box;
  padding: 52px ${({ theme }) => theme.padding.medium}
    ${({ theme }) => theme.spacing.spacingDesktop};
  gap: 52px;
  width: 100%;

  @media (max-width: 1600px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (max-width: 1024px) {
    grid-template-columns: minmax(0, 1fr);
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.spacing.spacingTablet};
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.padding.small}
      ${({ theme }) => theme.padding.xlarge};
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 2500px) {
    padding: 52px ${({ theme }) => theme.padding.large} 200px;
  }
  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.xlarge}
      ${({ theme }) => theme.padding.large} 200px;
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3500px) {
    padding: ${({ theme }) => theme.padding.xlarge} 1.5dvw 260px;
  }
  @media (min-width: 3800px) {
    padding: ${({ theme }) => theme.padding.xlarge} 1.5dvw 300px;
  }
  @media (min-width: 4500px) {
    padding: ${({ theme }) => theme.padding.xlarge} 1.5dvw 8dvw;
  }
`;

export const MainTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 52px;
  box-sizing: border-box;
  overflow: visible;
  min-width: 0;
  flex: 1 1 auto;

  @media (max-width: 1540px) {
    height: 100%;
  }
  @media (max-width: 1024px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 768px) {
    height: auto;
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};

  h1 {
    text-wrap: nowrap;
  }

  @media (max-width: 1365px) {
    h1 {
      text-wrap: auto;
    }
  }
`;

export const PicturesLine = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  box-sizing: border-box;
  min-width: 0;

  @media (max-width: 1540px) {
    height: 100%;
  }
  @media (max-width: 768px) {
    flex-direction: column;
  }

  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const PicturesColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
  min-width: 0;
  flex: 1 1 auto;

  @media (max-width: 1540px) {
    height: 100%;
  }

  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const MainPicture = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  width: 293px;
  min-width: 293px;
  aspect-ratio: 293 / 444;
  overflow: hidden;

  img {
    display: block;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 1600px) {
    width: clamp(260px, 21vw, 293px);
    min-width: clamp(260px, 21vw, 293px);
  }

  @media (max-width: 1024px) {
    width: min(38%, 293px);
    min-width: 240px;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-height: 86dvw;
    min-width: 0;

    img {
      width: 100%;
      height: auto;
    }
  }

  @media (min-width: 2500px) {
    width: 26dvw;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  @media (min-width: 3800px) {
    width: 30dvw;
  }
`;

export const ResinPicture = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  width: 239px;
  min-width: 239px;
  aspect-ratio: 239 / 330;
  overflow: hidden;

  img {
    display: block;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 1600px) {
    width: clamp(200px, 16vw, 239px);
    min-width: clamp(200px, 16vw, 239px);
  }
  @media (max-width: 1540px) {
    width: clamp(200px, 18vw, 260px);
    min-width: clamp(200px, 18vw, 260px);
  }
  @media (max-width: 1024px) {
    width: min(38%, 239px);
    min-width: 180px;
  }
  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    max-height: 66dvw;

    img {
      height: 100%;
    }
  }
  @media (max-width: 430px) {
    max-height: 80dvw;

    img {
      width: 100%;
      height: auto;
    }
  }

  @media (min-width: 2500px) {
    width: 24dvw;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;

export const OuterResinContainer = styled.div`
  display: flex;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.grey};
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;

  span {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.regular};
    padding: ${({ theme }) => theme.padding.regular};
    justify-content: center;
    min-width: 0;
  }

  @media (max-width: 1540px) {
    height: 100%;
  }
  @media (max-width: 768px) {
    height: auto;
  }
  @media (max-width: 430px) {
    flex-direction: column;
  }

  @media (min-width: 2000px) {
    height: 100%;
  }
  @media (min-width: 3000px) {
    span {
      padding: ${({ theme }) => theme.padding.medium};
    }
  }
  @media (min-width: 3400px) {
    span {
      padding: ${({ theme }) => theme.padding.large};
      border-radius: ${({ theme }) => theme.borderRadius.large};
    }
  }
`;

export const GreyCard = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.padding.regular};
  background-color: ${({ theme }) => theme.colors.lightGreyBlue};
  color: ${({ theme }) => theme.colors.offWhite};

  span {
    display: flex;
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.offWhite};
    border-radius: 999px;
  }

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: flex-end;

    p {
      margin-bottom: ${({ theme }) => theme.spacing.regular};
    }
  }

  @media (min-width: 2500px) {
    span {
      width: 42px;
      height: 42px;
      min-width: 42px;
      min-height: 42px;
    }

    svg {
      width: 28px;
      height: 28px;
    }
  }
  @media (min-width: 3000px) {
    gap: 30px;
    padding: ${({ theme }) => theme.padding.medium};

    span {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
    }

    svg {
      width: 38px;
      height: 38px;
    }
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};

    span {
      width: 68px;
      height: 68px;
      min-width: 68px;
      min-height: 68px;
    }

    svg {
      width: 46px;
      height: 46px;
    }
  }
  @media (min-width: 3800px) {
    max-width: 46dvw;

    span {
      width: 76px;
      height: 76px;
      min-width: 76px;
      min-height: 76px;
    }

    svg {
      width: 56px;
      height: 56px;
    }
  }
  @media (min-width: 4500px) {
    gap: ${({ theme }) => theme.spacing.medium};
    padding: 52px;

    span {
      width: 82px;
      height: 82px;
      min-width: 82px;
      min-height: 82px;
    }

    svg {
      width: 60px;
      height: 60px;
    }
  }
  @media (min-width: 5000px) {
    span {
      width: 92px;
      height: 92px;
      min-width: 92px;
      min-height: 92px;
    }

    svg {
      width: 68px;
      height: 68px;
    }
  }
`;

export const GreyCardTextBrake = styled.br`
  @media (max-width: 1600px) {
    display: none;
  }
  @media (min-width: 2000px) {
    display: none;
  }
`;

export const AccentCards = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  min-width: 0;
  max-width: 680px;
  height: 100%;

  @media (max-width: 1540px) {
    flex-direction: column;
    width: 330px;
  }
  @media (max-width: 1024px) {
    flex-direction: row;
    width: 100%;
    max-width: none;
  }
  @media (max-width: 520px) {
    flex-direction: column;
  }

  @media (min-width: 2500px) {
    max-width: 40dvw;
  }
  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const AccentCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.large};
  padding: ${({ theme }) => theme.padding.regular};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.lightBlue};
  border: 1.5px solid ${({ theme }) => theme.colors.accent};
  min-width: 330px;
  max-height: 350px;
  flex: 1 1 0;

  span {
    display: flex;
    width: 42px;
    height: 42px;
    min-width: 42px;
    min-height: 42px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.offWhite};
    border-radius: 999px;
  }

  p {
    margin: 0;

    @media (max-width: 520px) {
      font-size: ${({ theme }) => theme.typography.medium.fontSize};
    }
    @media (min-width: 2500px) {
      font-size: 1.75rem;
    }
    @media (min-width: 3000px) {
      font-size: 2rem;
    }
    @media (min-width: 3400px) {
      font-size: 2.5rem;
    }
    // @media (min-width: 3800px) {
    //   font-size: 3rem;
    // }
    @media (min-width: 4500px) {
      font-size: 3.25rem;
    }
    @media (min-width: 5000px) {
      font-size: 3.75rem;
    }
  }

  svg {
    width: 32px;
    height: 32px;
  }

  &:first-of-type {
    align-self: flex-end;
  }

  ::selection {
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.lightBlue};
  }

  @media (max-width: 520px) {
    width: 100%;
    min-width: 0;
    max-height: none;
    gap: ${({ theme }) => theme.spacing.medium};

    &:first-of-type {
      align-self: stretch;
    }
  }

  @media (min-width: 2500px) {
    max-height: fit-content;

    span {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
    }

    svg {
      width: 36px;
      height: 36px;
    }
  }
  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.medium};

    span {
      width: 56px;
      height: 56px;
      min-width: 56px;
      min-height: 56px;
    }

    svg {
      width: 46px;
      height: 46px;
    }
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};

    span {
      width: 72px;
      height: 72px;
      min-width: 72px;
      min-height: 72px;
    }

    svg {
      width: 58px;
      height: 58px;
    }
  }
  @media (min-width: 3800px) {
    span {
      width: 80px;
      height: 80px;
      min-width: 80px;
      min-height: 80px;
    }

    svg {
      width: 68px;
      height: 68px;
    }
  }
  @media (min-width: 4500px) {
    padding: 52px;
    gap: ${({ theme }) => theme.spacing.spacingTablet};

    span {
      width: 86px;
      height: 86px;
      min-width: 86px;
      min-height: 86px;
    }

    svg {
      width: 72px;
      height: 72px;
    }
  }
  @media (min-width: 5000px) {
    span {
      width: 96px;
      height: 96px;
      min-width: 96px;
      min-height: 96px;
    }

    svg {
      width: 80px;
      height: 80px;
    }
  }
`;

export const AccentCardHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  color: ${({ theme }) => theme.colors.lightGreyBlue};
`;

export const AccentCardHeader = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin: 0;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text};

  @media (max-width: 520px) {
    font-size: ${({ theme }) => theme.typography.medium.fontSize};
  }
`;

export const AccentCardContent = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.text};
`;

export const AccentCardValue = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  color: ${({ theme }) => theme.colors.accent};
  justify-content: space-between;
`;

export const AccentCardNumber = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xsmall};
  align-items: baseline;
`;

export const AccentCardTextBreak = styled.br`
  @media (max-width: 520px) {
    display: none;
  }
`;

export const InsulatingCompositionSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 52px;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.padding.xlarge}
    ${({ theme }) => theme.padding.medium};
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.grey};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};

  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.regular};
    gap: ${({ theme }) => theme.spacing.medium};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.small};
    gap: ${({ theme }) => theme.spacing.regular};
    border-radius: ${({ theme }) => theme.borderRadius.medium};

    p {
      text-align: left;
    }
  }

  @media (min-width: 2500px) {
    padding: 100px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3500px) {
    padding: 130px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 150px 1.5dvw;
  }
  @media (min-width: 4500px) {
    padding: 4dvw 1.5dvw;
  }
`;

export const InsulatingCompositionText = styled.div`
  width: min(930px, 50dvw);
  max-width: 100%;

  @media (max-width: 1600px) {
    width: min(930px, 70dvw);
  }
  @media (max-width: 1024px) {
    width: min(760px, 100%);
  }

  @media (min-width: 2500px) {
    width: 60dvw;
  }
`;

export const InsulatingCompositionTextBreak = styled.br`
  @media (max-width: 1024px) {
    display: none;
  }
  @media (min-width: 2500px) {
    display: none;
  }
`;

export const InsulatingCompositionPicturesLine = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  box-sizing: border-box;
  width: 100%;
  justify-content: center;

  @media (max-width: 900px) {
    flex-direction: column;
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.small};
  }

  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const InsulatingCompositionPicture = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  width: min(606px, calc((100% - 70px) / 3));
  min-width: 0;
  flex: 1 1 0;
  aspect-ratio: 606 / 306;
  overflow: hidden;
  cursor: zoom-in;

  img {
    display: block;
    // width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 1024px) {
    width: 100%;
    flex-basis: auto;
  }

  @media (min-width: 2500px) {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (min-width: 3400px) {
    // border-radius: ${({ theme }) => theme.borderRadius.medium};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;

export const TextLine = styled.div`
  display: flex;
  gap: 2px;
  align-items: flex-start;

  @media (min-width: 2500px) {
    gap: ${({ theme }) => theme.spacing.xsmall};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
`;

export const EquipmentSection = styled.section`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: 52px;
  padding: ${({ theme }) => theme.spacing.spacingDesktop}
    ${({ theme }) => theme.padding.medium};
  align-items: center;
  min-height: 70dvh;

  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.spacing.spacingTablet}
      ${({ theme }) => theme.padding.regular};
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.xlarge}
      ${({ theme }) => theme.padding.small};
  }

  @media (min-width: 2500px) {
    padding: 200px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3500px) {
    padding: 260px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 300px 1.5dvw;
    gap: ${({ theme }) => theme.spacing.spacingTablet};
  }
  @media (min-width: 4500px) {
    padding: 8dvw 1.5dvw;
    gap: ${({ theme }) => theme.spacing.spacingDesktop};
  }
`;

export const EquipmentContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.regular};
  width: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const EquipmentCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.darkBlue};
  flex: 1;
  min-width: 0;
  color: ${({ theme }) => theme.colors.offWhite};

  @media (max-width: 1024px) {
    flex-direction: row;
  }
  @media (max-width: 900px) {
    flex-direction: column;
  }

  @media (min-width: 2500px) {
    width: 24dvw;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;

export const EquipmentPicture = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  width: 100%;
  min-width: 0;
  aspect-ratio: 607 / 414;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 1024px) {
    width: 40dvw;
  }
  @media (max-width: 900px) {
    width: 100%;
  }

  @media (min-width: 2500px) {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
`;

export const EquipmentCardTextBox = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.spacing.regular}
    ${({ theme }) => theme.spacing.medium}
    ${({ theme }) => theme.spacing.medium};

  h2 {
    text-transform: uppercase;
  }

  @media (max-width: 1600px) {
    h2 {
      font-size: ${({ theme }) => theme.typography.h3.fontSize};
    }
  }
  @media (max-width: 1366px) {
    padding: ${({ theme }) => theme.spacing.regular}
      ${({ theme }) => theme.spacing.regular}
      ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 1280px) {
    h2 {
      font-size: 1.5rem;
    }
  }
  @media (max-width: 1024px) {
    h2 {
      font-size: ${({ theme }) => theme.typography.h2.fontSize};
    }
  }
  @media (max-width: 520px) {
    h2 {
      font-size: ${({ theme }) => theme.typography.body.fontSize};
    }
  }

  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.medium}
      ${({ theme }) => theme.spacing.medium}
      ${({ theme }) => theme.spacing.medium};
    gap: 52px;
  }
  @media (min-width: 3400px) {
    padding: ${({ theme }) => theme.spacing.medium};
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 4500px) {
    padding: 52px;
  }
`;

export const EquipmentCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
`;

export const EquipmentCardTextline = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xsmall};
  align-items: baseline;

  @media (min-width: 3000px) {
    gap: ${({ theme }) => theme.spacing.small};
  }
  @media (min-width: 3400px) {
    gap: 12px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
`;

export const AdvantagesCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.grey};
  padding: ${({ theme }) => theme.spacing.regular};
  gap: ${({ theme }) => theme.spacing.regular};
  flex: 1;
  min-width: 0;

  @media (max-width: 1024px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    > h2 {
      grid-column: 1 / -1;
      text-align: center;
    }
  }

  @media (max-width: 520px) {
    display: flex;
  }

  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.medium};
    gap: 30px;
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (min-width: 4500px) {
    gap: 52px;
    padding: 52px;
  }
`;

export const Advantage = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: flex-end;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.offWhite};
  padding: ${({ theme }) => theme.spacing.regular};
  gap: ${({ theme }) => theme.spacing.medium};
  height: 100%;

  span {
    display: flex;
    width: 42px;
    height: 42px;
    min-width: 42px;
    min-height: 42px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.grey};
    border-radius: 999px;
  }

  svg {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 1024px) {
    p {
      margin-bottom: ${({ theme }) => theme.spacing.regular};
    }
  }

  @media (max-width: 520px) {
    span {
      width: 32px;
      height: 32px;
      min-width: 32px;
      min-height: 32px;
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media (min-width: 2500px) {
    span {
      width: 48px;
      height: 48px;
      min-width: 48px;
      min-height: 48px;
    }

    svg {
      width: 32px;
      height: 32px;
    }
  }
  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.medium};
    gap: 0;

    p {
      margin: auto 0;
    }

    span {
      width: 52px;
      height: 52px;
      min-width: 52px;
      min-height: 52px;
    }

    svg {
      width: 42px;
      height: 42px;
    }
  }
  @media (min-width: 3400px) {
    border-radius: ${({ theme }) => theme.borderRadius.large};
    padding: ${({ theme }) => theme.padding.large};

    span {
      width: 68px;
      height: 68px;
      min-width: 68px;
      min-height: 68px;
    }

    svg {
      width: 54px;
      height: 54px;
    }
  }
  @media (min-width: 3800px) {
    span {
      width: 76px;
      height: 76px;
      min-width: 76px;
      min-height: 76px;
    }

    svg {
      width: 64px;
      height: 64px;
    }
  }
  @media (min-width: 4500px) {
    padding: 52px;

    span {
      width: 82px;
      height: 82px;
      min-width: 82px;
      min-height: 82px;
    }

    svg {
      width: 68px;
      height: 68px;
    }
  }
  @media (min-width: 5000px) {
    span {
      width: 92px;
      height: 92px;
      min-width: 92px;
      min-height: 92px;
    }

    svg {
      width: 76px;
      height: 76px;
    }
  }
`;

export const PatentSection = styled.section`
  display: flex;
  gap: 52px;
  box-sizing: border-box;
  padding: ${({ theme }) => theme.padding.xlarge}
    ${({ theme }) => theme.padding.medium};
  background-color: ${({ theme }) => theme.colors.lightBlue};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  justify-content: center;

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.regular};
    gap: ${({ theme }) => theme.spacing.medium};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.small};
    gap: ${({ theme }) => theme.spacing.regular};
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }

  @media (min-width: 2500px) {
    padding: 100px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
  @media (min-width: 3500px) {
    padding: 130px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 150px 1.5dvw;
  }
  @media (min-width: 4500px) {
    padding: 4dvw 1.5dvw;
  }
`;

export const Patents = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.regular};
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: 520px) {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  @media (min-width: 3000px) {
    gap: 24px;
  }
  @media (min-width: 3800px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const Patent = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 600px;
  min-height: 600px;
  aspect-ratio: 438 / 600;
  overflow: hidden;
  cursor: zoom-in;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 1600px) {
    height: 560px;
    min-height: 560px;
  }
  @media (max-width: 1024px) {
    width: 100%;
    height: auto;
    min-height: 0;
  }
  @media (max-width: 520px) {
    width: min(100%, 438px);
  }

  @media (min-width: 2500px) {
    width: 22dvw;
    min-height: 0;
    height: auto;
  }
  @media (min-width: 3400px) {
    img {
      width: auto;
    }
  }
  @media (min-width: 3800px) {
    width: 26dvw;
  }
  @media (min-width: 4500px) {
    width: 24dvw;
  }
`;

export const PatentInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  max-width: 40dvw;
  min-width: 0;

  @media (max-width: 1024px) {
    max-width: none;
    width: 100%;
  }

  @media (min-width: 3000px) {
    justify-content: center;
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const PatentTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const CTAContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 100%;

  > button {
    align-self: flex-end;
    justify-self: end;
  }

  @media (max-width: 520px) {
    width: 100%;

    > button {
      width: 100%;
      max-width: none;
      align-self: stretch;
    }

    > button > span:first-child {
      flex: 1;
    }
  }

  @media (min-width: 3000px) {
    height: auto;
  }
`;

export const WorksSection = styled.section`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.large};
  padding: ${({ theme }) => theme.spacing.spacingDesktop}
    ${({ theme }) => theme.padding.medium};
  align-items: center;

  h1,
  h3 {
    text-align: center;
  }

  @media (max-width: 1024px) {
    padding: ${({ theme }) => theme.spacing.spacingTablet}
      ${({ theme }) => theme.padding.regular};
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.xlarge}
      ${({ theme }) => theme.padding.small};
  }

  @media (min-width: 2500px) {
    padding: 200px ${({ theme }) => theme.padding.large};
  }
  @media (min-width: 3500px) {
    padding: 260px 1.5dvw;
  }
  @media (min-width: 3800px) {
    padding: 300px 1.5dvw;
    gap: ${({ theme }) => theme.spacing.spacingTablet};
  }
  @media (min-width: 4500px) {
    padding: 8dvw 1.5dvw;
    gap: ${({ theme }) => theme.spacing.spacingDesktop};
  }
`;

export const WorkExamples = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: 52px;
  width: 100%;

  @media (max-width: 1024px) {
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const WorkExample = styled.div`
  display: flex;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.medium};
  padding: ${({ theme }) => theme.padding.regular};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.large};

  @media (max-width: 1024px) {
    flex-direction: column;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    gap: ${({ theme }) => theme.spacing.medium};
  }
  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
    padding: ${({ theme }) => theme.padding.small};
    border-radius: ${({ theme }) => theme.borderRadius.regular};
  }

  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.medium};
  }
  @media (min-width: 3400px) {
    padding: ${({ theme }) => theme.padding.large};
  }
`;

export const WorkExamplePictureContainer = styled.div`
  display: flex;
  min-width: 28dvw;
  align-items: center;

  @media (max-width: 1024px) {
    width: 100%;
    min-width: 0;
    max-height: 520px;
    order: -1;
  }
`;

export const WorkExamplePicture = styled.div<{ $image: string }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 100%;
  aspect-ratio: 458 / 593;
  overflow: hidden;
  cursor: zoom-in;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 1024px) {
    width: 100%;
    height: auto;
    max-height: 520px;
  }
`;

export const WorkExampleInner = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing.medium};
  width: 100%;
  min-width: 0;

  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 3000px) {
    gap: 52px;
  }
  @media (min-width: 3400px) {
    gap: ${({ theme }) => theme.spacing.large};
  }
`;

export const WorkExampleHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  h2 {
    text-transform: uppercase;
    color: #6c7788b3;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
  }

  h1 {
    margin: 0;
    color: #6c778866;
    font-size: 4rem;
    line-height: 3.25rem;
    font-weight: ${({ theme }) => theme.fontWeight.medium};

    @media (min-width: 2500px) {
      font-size: 4.25rem;
      line-height: 3.5rem;
    }
    @media (min-width: 3400px) {
      font-size: 5.25rem;
      line-height: 4.75rem;
    }
    @media (min-width: 3800px) {
      font-size: 5.75rem;
      line-height: 5rem;
    }
    @media (min-width: 4500px) {
      font-size: 6.25rem;
      line-height: 5.5rem;
    }
    @media (min-width: 5000px) {
      font-size: 6.75rem;
      line-height: 6rem;
    }
  }

  @media (max-width: 1024px) {
    h1 {
      font-size: ${({ theme }) => theme.typography.h1.fontSize};
    }
  }
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: flex-end;
    gap: ${({ theme }) => theme.spacing.xsmall};

    h2 {
      align-self: flex-start;
    }
  }
`;

const ExampleHeader = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
  padding: ${({ theme }) => theme.padding.small}
    ${({ theme }) => theme.padding.regular};
  border-radius: 999px;
  min-width: 180px;
  width: fit-content;
  box-sizing: border-box;
  text-transform: uppercase;
  z-index: 2;

  @media (min-width: 2500px) {
    svg {
      width: 28px;
      height: 28px;
    }
  }
  @media (min-width: 3000px) {
    gap: 30px;
    padding: 12px ${({ theme }) => theme.padding.medium};

    svg {
      width: 32px;
      height: 32px;
    }
  }
  @media (min-width: 3400px) {
    padding: ${({ theme }) => theme.borderRadius.regular}
      ${({ theme }) => theme.padding.large};

    svg {
      width: 42px;
      height: 42px;
    }
  }
  @media (min-width: 3800px) {
    svg {
      width: 54px;
      height: 54px;
    }
  }
  @media (min-width: 4500px) {
    padding: ${({ theme }) => theme.borderRadius.medium} 52px;

    svg {
      width: 64px;
      height: 64px;
    }
  }
  @media (min-width: 5000px) {
    svg {
      width: 68px;
      height: 68px;
    }
  }
`;

export const ProblemHeader = styled(ExampleHeader)`
  background-color: ${({ theme }) => theme.colors.mediumRed};
  color: ${({ theme }) => theme.colors.darkRed};
`;

export const SolutionHeader = styled(ExampleHeader)`
  background-color: ${({ theme }) => theme.colors.darkMediumGreen};
  color: ${({ theme }) => theme.colors.darkGreen};
`;

export const ExampleBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ExampleInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
  border-radius: ${({ theme }) => theme.borderRadius.regular};
  padding: ${({ theme }) => theme.padding.large}
    ${({ theme }) => theme.padding.regular}
    ${({ theme }) => theme.padding.regular};
  position: relative;
  transform: translate(0, -24px);

  @media (max-width: 520px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }

  @media (min-width: 2500px) {
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.medium}
      ${({ theme }) => theme.padding.medium};
  }
  @media (min-width: 3400px) {
    padding: ${({ theme }) => theme.padding.large};
    border-radius: ${({ theme }) => theme.borderRadius.large};
  }
  @media (min-width: 4500px) {
    padding: 52px;
  }
`;

export const ProblemInnerContainer = styled(ExampleInnerContainer)`
  background-color: ${({ theme }) => theme.colors.lightRed};
`;

export const SolutionInnerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing.small};

  @media (max-width: 1540px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    display: grid;
    grid-template-columns: 1fr;
  }

  @media (min-width: 2500px) {
    gap: 12px;
  }
  @media (min-width: 3000px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (min-width: 3800px) {
    gap: 30px;
  }
`;

export const SolutionInnerGridThree = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${({ theme }) => theme.spacing.small};

  @media (max-width: 1540px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    display: grid;
    grid-template-columns: 1fr;
  }

  @media (min-width: 2500px) {
    gap: 12px;
  }
  @media (min-width: 3000px) {
    gap: ${({ theme }) => theme.spacing.regular};
  }
  @media (min-width: 3800px) {
    gap: 30px;
  }
`;

export const SolutionInnerContainer = styled(ExampleInnerContainer)`
  background-color: ${({ theme }) => theme.colors.lightGreen};
  flex: 1;
  padding: ${({ theme }) => theme.padding.large}
    ${({ theme }) => theme.padding.regular}
    ${({ theme }) => theme.padding.xlarge};

  span {
    display: flex;
    width: 44px;
    height: 44px;
    min-width: 44px;
    min-height: 44px;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.lightMediumGreen};
    border-radius: 999px;
    color: ${({ theme }) => theme.colors.mediumGreen};
    align-self: flex-end;
  }

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.padding.regular}
      ${({ theme }) => theme.padding.large};
  }

  @media (min-width: 2500px) {
    span {
      width: 54px;
      height: 54px;
      min-width: 54px;
      min-height: 54px;
    }
  }
  @media (min-width: 3000px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.medium}
      ${({ theme }) => theme.padding.xlarge};

    span {
      width: 64px;
      height: 64px;
      min-width: 64px;
      min-height: 64px;
    }
  }
  @media (min-width: 3400px) {
    padding: ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.large}
      ${({ theme }) => theme.padding.xlarge};

    span {
      width: 68px;
      height: 68px;
      min-width: 68px;
      min-height: 68px;
    }
  }
  @media (min-width: 3800px) {
    span {
      width: 76px;
      height: 76px;
      min-width: 76px;
      min-height: 76px;
    }
  }
  @media (min-width: 4500px) {
    padding: 52px 52px ${({ theme }) => theme.spacing.spacingTablet};

    span {
      width: 86px;
      height: 86px;
      min-width: 86px;
      min-height: 86px;
    }
  }
  @media (min-width: 5000px) {
    span {
      width: 92px;
      height: 92px;
      min-width: 92px;
      min-height: 92px;
    }
  }
`;

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.text};
  text-underline-offset: 6px;
  transition: color 0.4s, text-decoration-color 0.4s ease;

  &:hover {
    text-decoration: underline transparent;
    color: ${({ theme }) => theme.colors.accent};
  }
`;
